export default "__VITE_ASSET__BRbBZ_2j__"